export const SNACKBAR_ID_PREFIX = 'move-widget';
